"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _reactSvg = require("react-svg");
var _lodash = require("lodash");
var _common = require("../../../core/utils/common");
var _Anchor = _interopRequireDefault(require("../../Atoms/Anchor"));
var _Image = _interopRequireDefault(require("../../Atoms/Image"));
var _Divider = _interopRequireDefault(require("../../Atoms/Divider"));
var _Button = _interopRequireDefault(require("../../Atoms/Button"));
var _MyAccountContainer = _interopRequireDefault(require("../Header/MyAccountContainer"));
var _QuickOrderOverLay = _interopRequireDefault(require("../Header/QuickOrderOverLay"));
var _screenSizes = _interopRequireDefault(require("../../../core/utils/screenSizes"));
require("./TopNavBar.scss");
require("./hamburger.scss");
var keycode = _interopRequireWildcard(require("../../../core/utils/keyCodes"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || (0, _typeof2.default)(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var HeaderSearchBar = (0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('../HeaderSearchBar'));
  });
});
var TopNavBar = function TopNavBar(props) {
  var logo = (0, _lodash.get)(props, 'logo', {});
  var navItems = (0, _lodash.get)(props, 'navItems', {});
  var myAccountConfig = (0, _lodash.get)(props, 'myAccountConfig', {});
  var logoLink = (0, _lodash.get)(props, 'logoLink');
  var toggleMobileSearchBar = (0, _lodash.get)(props, 'toggleMobileSearchBar');
  var overLayClass = 'overlay-active';
  var loginState = (0, _lodash.get)(props, 'myAccountConfig.loginState', false);
  var searchBarItems = (0, _lodash.get)(myAccountConfig, 'searchBarItems', {});
  var hideIcons = (0, _lodash.get)(myAccountConfig, 'headerContent.hideIcons', false);
  var isEProc = (0, _lodash.get)(props, 'isEProc', false);
  var searchBarId = (0, _lodash.get)(props, 'id', '');
  var countryLanguageProps = props.countryLanguageProps;
  var onSearchRequest = searchBarItems.onSearchRequest,
    suggestions = searchBarItems.suggestions,
    iconSearch = searchBarItems.iconSearch,
    iconClear = searchBarItems.iconClear,
    searchPath = searchBarItems.searchPath,
    placeholderDesktop = searchBarItems.placeholderDesktop,
    placeholderMobile = searchBarItems.placeholderMobile,
    searchBarSubmit = searchBarItems.searchBarSubmit,
    defaultConfig = searchBarItems.defaultConfig,
    labels = searchBarItems.labels,
    recentlySearched = searchBarItems.recentlySearched,
    multipleIconUrl = searchBarItems.multipleIconUrl,
    searchBarInteraction = searchBarItems.searchBarInteraction;
  var getOverLayClass = function getOverLayClass(className) {
    if (className === void 0) {
      className = '';
    }
    return className ? overLayClass + "__" + className : overLayClass;
  };
  var openOverlay = function openOverlay(className) {
    if (className === void 0) {
      className = '';
    }
    document.querySelector('body').classList.add(getOverLayClass(className));
  };
  var closeOverlay = function closeOverlay(className) {
    if (className === void 0) {
      className = '';
    }
    document.querySelector('body').classList.remove(getOverLayClass(className));
  };
  var handleClickToggle = function handleClickToggle(className) {
    if (className === void 0) {
      className = '';
    }
    document.querySelector('body').classList.toggle(getOverLayClass(className));
  };
  var getSvgClassName = function getSvgClassName(id, cartTotalItems) {
    var cartTotalClass = '';
    if (!(0, _lodash.isEmpty)(cartTotalItems)) {
      var cartItemSize = (0, _lodash.size)(cartTotalItems);
      if (cartItemSize === 1) {
        cartTotalClass = 'badge__single-limit';
      } else if (cartItemSize === 2) {
        cartTotalClass = 'badge__min-limit';
      } else {
        cartTotalClass = 'badge__max-limit';
      }
    }
    return id === 'cart' && !(0, _lodash.isEmpty)(cartTotalItems) ? "header-svg " + cartTotalClass : 'header-svg';
  };
  var handleHamburger = function handleHamburger() {
    props.hamburgerClick();
    toggleMobileSearchBar(false, false);
    overLayClass = 'no-scroll';
    if (!props.hamburgerValue) {
      openOverlay();
    } else {
      closeOverlay();
    }
  };
  var renderSearchBar = function renderSearchBar() {
    return _react.default.createElement("li", {
      className: "top-bar__nav__item top-bar__nav__search-bar"
    }, _react.default.createElement(_react.Suspense, {
      fallback: _react.default.createElement("div", null)
    }, _react.default.createElement(HeaderSearchBar, {
      onSearchRequest: onSearchRequest,
      suggestions: suggestions,
      minSearchCharacters: "1",
      maxSuggestions: "10",
      iconSearch: iconSearch,
      iconClear: iconClear,
      searchPath: searchPath,
      placeholderDesktop: placeholderDesktop,
      placeholderMobile: placeholderMobile,
      defaultConfig: defaultConfig,
      searchBarSubmit: searchBarSubmit,
      labels: labels,
      recentlySearched: recentlySearched,
      toggleMobileSearchBar: toggleMobileSearchBar,
      multipleIconUrl: multipleIconUrl,
      isEProc: isEProc,
      searchBarInteraction: searchBarInteraction,
      id: searchBarId
    })));
  };
  var topNavBarUserLoginState = "top-bar__nav__user top-bar__nav__item " + (loginState ? 'loggedIn' : '');
  var topNavBarItemLoginState = function topNavBarItemLoginState(item) {
    return "top-bar__nav__" + item.id + " top-bar__nav__item " + (loginState ? 'loggedIn' : '');
  };
  var desktopClosingOverlay = function desktopClosingOverlay(item) {
    if (!_screenSizes.default.isMobile()) {
      closeOverlay(item.id);
    }
  };
  var eventClick = function eventClick(e, item) {
    if (e.charCode === keycode.SPACE) {
      e.preventDefault();
      handleClickToggle(item.id);
    }
  };
  var renderCountryLanguageHeader = function renderCountryLanguageHeader() {
    var globeIcon = countryLanguageProps.config.globeIcon,
      disableFooterSelector = countryLanguageProps.disableFooterSelector,
      isEprocurementApp = countryLanguageProps.isEprocurementApp;
    var isDisableCountryLanguage = (0, _common.disableCountryLanguage)(disableFooterSelector);
    var className = isDisableCountryLanguage ? 'global-icon-disabled' : '';
    return !isEprocurementApp && _react.default.createElement("li", {
      className: "top-bar__nav__item top-bar__nav__search-bar global-icon-tablet-mobile " + className,
      "data-locator": "top-bar__nav__country_lang"
    }, _react.default.createElement("div", {
      className: "cmp-header__selector__region"
    }, _react.default.createElement(_reactSvg.ReactSVG, {
      src: globeIcon,
      wrapper: "span",
      "data-locator": "language-selector-logo"
    })));
  };
  var myAccountContainerProps = (0, _extends2.default)({}, props, {
    myAccountConfig: myAccountConfig,
    closeOverlay: closeOverlay
  });
  var buttonProps = {
    elementLocator: 'button-header-hamburger',
    onClick: handleHamburger
  };
  return _react.default.createElement("div", {
    className: "row",
    "data-locator": "top-nav-bar-container"
  }, _react.default.createElement("h1", {
    className: "top-bar-logo",
    "data-locator": "top-bar-logo"
  }, _react.default.createElement(_Anchor.default, {
    to: logoLink,
    elementLocator: "link-top-bar-logo"
  }, _react.default.createElement(_Image.default, {
    className: "top-bar-logo-img",
    src: logo.url,
    alt: logo.name,
    elementLocator: "image-top-bar-logo"
  }))), !hideIcons && _react.default.createElement("nav", {
    className: "top-bar-nav"
  }, _react.default.createElement("ul", {
    className: "top-bar-nav-ul"
  }, searchBarItems && renderSearchBar(), renderCountryLanguageHeader(), navItems.map(function (item) {
    return !item.disabled && _react.default.createElement("li", (0, _extends2.default)({
      key: item.id,
      "data-locator": "header-section-" + item.elementLocator,
      className: (0, _common.getTernaryCondition)(item.id === 'myAccount', topNavBarUserLoginState, topNavBarItemLoginState(item))
    }, item.id === 'myAccount' && {
      onMouseOut: function onMouseOut() {
        desktopClosingOverlay(item);
      }
    }, item.id === 'quickOrder' && {
      onMouseLeave: function onMouseLeave() {
        desktopClosingOverlay(item);
      }
    }, (0, _common.getOrCondition)(item.id === 'myAccount', item.id === 'quickOrder') && {
      onMouseOver: function onMouseOver() {
        if (!_screenSizes.default.isMobile()) {
          openOverlay(item.id);
        }
      }
    }), item.id !== 'mobile' ? _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Anchor.default, (0, _extends2.default)({
      className: "top-bar-nav-link top-bar-nav-link-mobile",
      "aria-label": item.label,
      elementLocator: "link-header-my-account-" + item.elementLocator,
      to: item.url
    }, item.id === 'myAccount' && {
      handleLinkClick: function handleLinkClick(e) {
        if (_screenSizes.default.isMobile()) {
          e.preventDefault();
          handleClickToggle(item.id);
        } else if (!item.url) {
          e.preventDefault();
        }
      },
      onKeyPress: function onKeyPress(e) {
        return eventClick(e, item);
      }
    }), _react.default.createElement("span", {
      id: "header-" + item.elementLocator,
      className: "header-label",
      "data-locator": "header-label-" + item.elementLocator
    }, item.label), item.icon && _react.default.createElement(_reactSvg.ReactSVG, {
      wrapper: "span",
      alt: item.label,
      src: item.icon,
      className: getSvgClassName(item.id, item.cartTotalItems),
      "data-locator": "header-" + item.elementLocator + "-icon",
      value: item.cartTotalItems
    })), item.id === 'myAccount' && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_MyAccountContainer.default, (0, _extends2.default)({}, myAccountContainerProps, {
      userLabel: item.name
    }))), item.id === 'quickOrder' && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_QuickOrderOverLay.default, myAccountContainerProps))) : _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Divider.default, {
      type: "h-small",
      className: "top-bar__nav__mobile__divider"
    }), _react.default.createElement(_Button.default, (0, _extends2.default)({}, buttonProps, {
      className: "hamburger hamburger--slider " + (0, _common.getTernaryCondition)(props.hamburgerValue, 'is-active', '')
    }), _react.default.createElement("span", {
      className: "visually-hidden"
    }, "Hamburger"), _react.default.createElement("span", {
      className: "hamburger-box"
    }, _react.default.createElement("span", {
      className: "hamburger-inner"
    })))));
  }))));
};
TopNavBar.defaultProps = {
  logo: {
    url: '#',
    name: 'logo'
  },
  navItems: [],
  closeOverlay: function closeOverlay() {
    /* default closeOverlay handler */
  },
  hamburgerClick: function hamburgerClick() {
    /* default hamburgerClick handler */
  },
  hamburgerValue: false,
  toggleMobileSearchBar: function toggleMobileSearchBar() {
    /* default toggleMobileSearchBar handler */
  }
};
var _default = TopNavBar;
exports.default = _default;
module.exports = exports["default"];